import { TableCell, TableRow } from "@mui/material"

import { useEffect, useState } from "react"

import { ActivityRow } from "./ActivityRow"
import { Activity, getActivity } from "@/api/activity-api"

import { AsyncTable } from "@/components/AsyncTable"
import { ErrorBoundary } from "@/components/ErrorBoundary"
import { REFRESH_INTERVAL } from "@/settings"

const pageSize = 25

export function EntityActivity(props: { entityId: string }) {
  const { entityId } = props
  const [, setRefresh] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setRefresh(Math.random())
    }, REFRESH_INTERVAL)

    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <>
      <AsyncTable
        size="small"
        sx={{
          "& .MuiTableBody-root": {
            maxHeight: 500, // TODO
            overflowY: "auto",
          },
        }}
        headerCells={[]}
        initialSortDir="desc"
        initialSortField={"timestamp" satisfies keyof Activity}
        pageSize={pageSize}
        fetchFunction={async (offset, ascending, sortField, lastRecord) => {
          const [count, records] = await getActivity(
            pageSize,
            lastRecord?.cursor,
            ascending,
            entityId,
          )

          // if (count !== undefined && onCountReady) {
          //   onCountReady(count)
          // }

          return records
        }}
        renderRow={(activity: Activity) => {
          return (
            <TableRow
              key={activity.txId}
              sx={{
                "&:nth-of-type(2) > td": {
                  borderTopRightRadius: 20,
                  borderTopLeftRadius: 20,
                },
                "&:last-of-type > td": {
                  borderBottomRightRadius: 20,
                  borderBottomLeftRadius: 20,
                },
              }}
            >
              <TableCell
                sx={{
                  backgroundColor: (theme) => theme.palette.background.paper,
                  borderBottom: "4px solid",
                  borderColor: (theme) => theme.palette.background.default,
                  paddingY: 2,
                }}
              >
                <ErrorBoundary fallback={<>Unknown activity</>}>
                  <ActivityRow activity={activity} />
                </ErrorBoundary>
              </TableCell>
            </TableRow>
          )
        }}
      />
    </>
  )
}
